import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_COACH_SAGA } from "../sagaTypes";
import { loaderAction, coachFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getCoachesSagaAction, getSubscriptionDataSagaAction } from "../sagaActions";
import { COACH_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_coach`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateCoach(args) {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('coach_id', args.data.id);
        formData.append('image', args.data.image?.file || args.data.image);
        formData.append('name', args.data.name);
        formData.append('phone', args.data.phone);
        formData.append('email', args.data.email);
        formData.append('description', args.data.description);
        formData.append('hide', args.data.hide);
        formData.append('establishments', args.data.establishments);
        formData.append('links', args.data.links);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Получаем обновлённые данные о заведении
            yield put(getSubscriptionDataSagaAction());
            // Обновляем список трененов
            yield put(getCoachesSagaAction());
            // Очищаем форму тренера
            yield put(coachFormAction(COACH_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateCoach() {
    yield takeLatest(UPDATE_COACH_SAGA, workerUpdateCoach);
}